/* Modulo blog carousel — shared scroll-snap rail controller for
   section-blog-rail AND section-blog-slider. Neutral namespace: it keys off
   data-modulo-blogc / data-blogc-* attributes ONLY, so each sibling keeps its
   own BEM classes and CSS file. Edit with both sections in mind.
   The rail swipes/scrolls natively with no JS; this only wires the arrows,
   their disabled state, and the optional sliding-window progress thumb.
   Vanilla, RTL- and reduced-motion aware, self-healing across theme-editor
   re-renders. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  // Held live, not cached to a boolean: the CSS side responds to an OS
  // reduced-motion toggle mid-session via @media, so the JS must too.
  var REDUCE_MQ = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduce() { return !!(REDUCE_MQ && REDUCE_MQ.matches); }

  function init(root) {
    if (!root || root.dataset.moduloBlogcReady === '1') return;
    root.dataset.moduloBlogcReady = '1';

    var rail = root.querySelector('[data-blogc-rail]');
    if (!rail) return;

    var prev = root.querySelector('[data-blogc-prev]');
    var next = root.querySelector('[data-blogc-next]');
    var track = root.querySelector('[data-blogc-track]');
    var thumb = root.querySelector('[data-blogc-thumb]');
    var rtl = window.getComputedStyle(rail).direction === 'rtl';

    // Card step (width + gap) is constant between resizes — measuring it every
    // scroll frame forces a layout on the one device class that actually swipes.
    var stepCache = 0;
    function step() {
      if (stepCache > 0) return stepCache;
      var card = rail.firstElementChild;
      if (!card) return rail.clientWidth * 0.8;
      var cs = window.getComputedStyle(rail);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      var w = card.getBoundingClientRect().width;
      if (w <= 0) return rail.clientWidth * 0.8;
      stepCache = w + gap;
      return stepCache;
    }

    function sync() {
      if (!root.isConnected) return;
      var max = rail.scrollWidth - rail.clientWidth;
      var pos = Math.abs(rail.scrollLeft);

      if (prev) prev.disabled = pos <= 2;
      if (next) next.disabled = pos >= max - 2;

      // Sliding-window thumb: width is the visible fraction, travel measured
      // in px from the real boxes so CSS and JS can't drift apart. Negated in
      // RTL — translate is not direction-aware even though inset-inline is.
      if (thumb && track) {
        var frac = rail.scrollWidth > 0 ? rail.clientWidth / rail.scrollWidth : 1;
        var w = Math.max(28, Math.round(frac * track.clientWidth));
        thumb.style.width = w + 'px';
        var room = track.clientWidth - w;
        var pct = max > 0 ? pos / max : 0;
        thumb.style.translate = (pct * room * (rtl ? -1 : 1)) + 'px';
      }
    }
    root._blogcSync = function () { stepCache = 0; sync(); };

    function page(dir) {
      var s = step();
      var perClick = Math.max(1, Math.floor(rail.clientWidth / s));
      var delta = dir * s * perClick * (rtl ? -1 : 1);
      rail.scrollBy({ left: delta, behavior: reduce() ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });

    var raf = null;
    rail.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    }, { passive: true });

    sync();
  }

  // ONE shared resize listener that re-queries live roots. A per-instance
  // listener would accumulate across theme-editor re-renders (the editor swaps
  // in a fresh node, so the dataset guard can't dedupe) and each dead closure
  // would pin its whole detached card subtree.
  var rt = null;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () {
      var els = document.querySelectorAll('[data-modulo-blogc]');
      for (var i = 0; i < els.length; i++) {
        if (typeof els[i]._blogcSync === 'function') els[i]._blogcSync();
      }
    }, 100);
  });

  function boot(scope) {
    var els = (scope || document).querySelectorAll('[data-modulo-blogc]');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // Shopify theme editor: (re)init when a section is added/redrawn.
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
